<template>
  <entity-view
    :item-schemas="itemSchemas"
    :select="select"
    :items="items"
    :readonly="readonly"
    :title="$t('draft_lawyer_history')"
    :pagination="pagination"
    :externalActions="externalActions"
    :options="options"
    actionName="operation"
    @items-refresh="itemsRefresh"
    @page-change="pageChange"
  >
  </entity-view>
</template>

<script>
import EntityView from "../components/EntityView.vue";
import reviewAction from "../common/review_action";

export default {
  components: { EntityView },
  props: {
    draftLawyerId: {}
  },
  data: () => ({
    title: "DraftLawyerHistory",
    select: false,
    readonly: true,
    options: {
      dateTimePattern: "YYYY-MM-DD HH:mm:ss",
      showAction: false,
    },
    expendFilter: {
      effected: {
        last: 10,
      },
    },
    pagination: {
      current: 1,
      pageCount: 1,
      pageSize: 10,
    },
    itemSchemas: [
      {
        name: "id",
        value: "id",
        type: "number",
      },
       {
        name: "lawyerId",
        value: "lawyerId",
        type: "number",
      },
      {
        name: "draftId",
        value: "draftId",
        type: "number",
      },
      {
        name: "action",
        value: "action",
        type: "dropdown",
        dropdown: reviewAction.data,
        localized: true
      },
      {
        name: "comment",
        value: "comment",
        type: "string",
      },
      {
        name: "modifiedAt",
        value: "modifiedAt",
        type: "date",
      },
    ],
    items: [],
    externalActions: [],
    criterias: []
  }),
  mounted() {
    this.updateSchemaData();
  },
  computed: {},
  methods: {
    updateSchemaData() {
      this.localizeSchema(this.itemSchemas);
    },
    updateComponent() {
      this.refresh();
    },
    refresh(criterias) {
      let _this = this;
      if (criterias != undefined) {
        this.criterias = criterias;
      }
      let postData = {
        pagination: this.pagination,
        criterias: criterias,
      };
      this.post("/api/lawyer/" + this.draftLawyerId + "/histories", postData, {
        callback: function (data) {
          let pg = {
            pageCount: data.data.pages,
            pageSize: data.data.size,
            current: data.data.current,
          };
          _this.pagination = pg;
          _this.items = data.data.records;
        },
      });
    },
    itemsRefresh() {
      this.refresh(this.criterias);
    },
    pageChange(pagination) {
      this.pagination = pagination;
      this.refresh();
    },
    itemAction(name) {
      if (name === "insert") {
        this.itemCreate();
      }
    },
  },
};
</script>

<style scoped>
.main-container {
  margin-left: 384px;
}
.nav-drawer {
  margin-top: 64px;
}
.filter-label {
  margin-left: -12px !important;
}
</style>
